import "./Login.css"
import Logo from "../assets/images/company_logo_svg.svg";
import IconEye from "../assets/images/eye.svg";
import IconEyeSlash from "../assets/images/eye-slash.svg";

import { useData} from "../consts.js";
import { UrlsSettings, getDataTokenValue, removeDataToken, setUserInfo, getUserInfo } from "../axios_with_token.js";

import React, { useEffect, useState, useRef } from "react";

import { doLogin } from "../axios_with_token.js";

import {useForm} from "react-hook-form";

import { createPortal } from 'react-dom';
import Cookies from "js-cookie";

import { useContext, createContext } from "react";

const loginContext = createContext();
export function useLoginContext(){
    return useContext(loginContext);
}

export default function LoginProvider({children, username, password}){
    const [loggedin, setLoggedin] = useState(false);
    const [userInfo, setUserInfo] = useState({});

    function logout(){
        Cookies.set('loggedIn', JSON.stringify(false));
        Cookies.set('userInfo', JSON.stringify({}));
        setLoggedin(false);
    }

    function Login({setLoggedin, setUserInfo}){
        // const [loggedin, setLoggedin] = useState(false);
        // const [email, setEmail] = useState("");
        // const [password, setPassword] = useState("");
        const {register, handleSubmit, formState:{errors}} = useForm();
        const [showUrlSettings, setShowUrlSettings] = useState(false);
        const [error, setError] = useState(false);
        // const [loggedin, setLoggedin] = useState(false);

        // const {loggedIn, setLoggedIn, setUserInfo} = useData();

        const onSubmit = data=>doLogin(data).then(res=>{
            setLoggedin(true);
            setUserInfo(res.data);
            // useLoginData.userInfo = res.data;
        }).catch(err=>{
            setError(err);
        });

        // show/hide password icon
        const [pwdType, setPwdType] = useState('password');
        const handleTglPwd = () => {
            if (pwdType==='password'){
                setIcon("hide");
                setPwdType('text')
            } else {
                setIcon("show")
                setPwdType('password')
            }
        }

        const [icon, setIcon] = useState("show");

        // return <div>
        //     <h1>{JSON.stringify(loggedin)}</h1>
        //     [{loggedin&&children}]
        //     {!loggedin&&<button type="button"
        //         onClick={evt=>{
                    
        //             setLoggedin(true);
        //         }}
        //     >login</button>}
        // </div>

        // return createPortal(test?<h1>logged in true [{loggedIn}] [{test}]</h1>:<h1>logged in false [{loggedIn}] [{test}]</h1>, document.getElementById('dialog-root'))
        // return createPortal(loggedIn?'':<div>login</div>, document.getElementById('dialog-root'));
        return loggedin?'':createPortal(<main className='login' style={{"zIndex":"9999999999"}}>
                <div className="modal show" tabIndex="-1">
                    <div className="modal-dialog modal-fullscreen-sm-down">
                        <div className="modal-content container shadow-lg">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="modal-header">
                                    <img src={Logo} />
                                    <h3 className="modal-title" >Log In</h3>
                                    {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> */}
                                </div>
                                <div className="modal-body col-md-10 offset-md-1">
                                        <div className="mb-3">
                                            <label htmlFor="username" className="form-label">User name</label>
                                            <input type="text" id="username" name="username" className="form-control" {...register("username", {required: true})} />
                                            {errors.username && <p className="fld-error">This field is required</p>}
                                            {/* <label htmlFor="exampleInputEmail1" className="form-label">Email address</label> */}
                                            {/* <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" /> */}
                                            {/* <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div> */}
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="password" className="form-label">Password</label>
                                            <div className="input-group">
                                                <input type={pwdType} className="form-control" id="password" name="password" {...register("password", {required:true})} />
                                                <span className="input-group-text align-middle" onClick={handleTglPwd}>
                                                    <img src={icon==="show"?IconEye:IconEyeSlash} className="align-middle pe-none p-0 m-0" style={{"width": "1.5em"}} />
                                                </span>                                            
                                            </div>

                                            {errors.password && <p className="fld-error">This field is required</p>}
                                        </div>
                                        {/* <div className="mb-3 form-check">
                                            <input type="checkbox" className="form-check-input" id="checkMeOut" name="checkMeOut" />
                                            <label className="form-check-label" htmlFor="checkMeOut">Check me out</label>
                                        </div> */}
                                        {error&&<div className="text-danger">{(error||{}).message||'unkown error'}</div>}
                                </div>
                                <div className="modal-footer">
                                        <button type="button" className="btn btn-primary"
                                            onClick={evt=>setShowUrlSettings(!showUrlSettings)}
                                        >toggle url settings</button>
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    <button type="button" className="btn btn-primary">Save changes</button> */}
                                </div>
                            </form>
                            <div className={"container "+(showUrlSettings?'':' d-none')}>
                                <UrlsSettings></UrlsSettings>
                            </div>                        
                        </div>

                    </div>
                </div>
            </main>,
            document.getElementById('dialog-root')
        );
    };

    // [] persist log in data
    useEffect(_=>{
        if(loggedin)return;
        // setLoggedin(Cookies.get('loggedIn'));
        // setUserInfo(Cookies.get('userInfo'));
    }, [])

    // [] automatic log in
    useEffect(_=>{
        if(loggedin)return;
        if(username){
            // const data = new FormData();
            // data.username = username;
            // data.password = password;
            doLogin({
                username,
                password
            }).then(res=>{
                setLoggedin(true);
                setUserInfo(res.data);
                // useLoginData.userInfo = res.data;
            }).catch(err=>{
                // console.log(err);
            });
        }

    }, [])

    if(username && !loggedin){
            return <div>logging in ...</div>;
    }

    return <loginContext.Provider
        value={{
            loggedin,
            setLoggedin,
            logout,
            userInfo
        }}
    >
        {!loggedin&&<Login
            setLoggedin = {setLoggedin}
            setUserInfo= {setUserInfo}
        ></Login>}
        {loggedin&&children}
    </loginContext.Provider>;
}

// // const useLoginData = {};
// export function useLogin({reg, refresh}){
//     console.log('++++++++++++++++refresh:', refresh);
//     // check logged in
//     // useEffect(_=>{
//     //     setLoggedin(getDataToken());
//     // }, [loggedin])
//     const refData = useRef({});
//     const [loggedin, setLoggedin] = useState(getDataTokenValue());
//     // console.log('logged in [', loggedin);
//     const cbs = {};

//     function LoginResult({children}){
//         const [_, _refresh] = useState();

//         useEffect(_=>{
//             console.log('log in status change', loggedin);
//         }, [loggedin])

//         return <div>
//             {(!loggedin)&&<Login></Login>}
//             {loggedin&&children}
//         </div>;
//     }

//     // function regSetLoggedin(fn){
//     // if(reg){
//     //     useLoginData.setLoggedin = setLoggedin;
//     //     useLoginData.userInfo = getUserInfo();
//     //         // Cookies.set('loggedIn', true);
//     //         // Cookies.set('userInfo', JSON.stringify(res.data));
//     // }

//     function logout(){
//         removeDataToken();
//         // const setLoggedin = useLoginData.setLoggedin;
//         // if(setLoggedin)setLoggedin(false);
//         setLoggedin(false);
//         console.log('refresh:', refresh);
//         refresh&&refresh();
//     }

//     // function _getUserInfo(){
//     //     return useLoginData.userInfo;
//     // }

//     function Login({}){
//         // const [loggedin, setLoggedin] = useState(false);
//         // const [email, setEmail] = useState("");
//         // const [password, setPassword] = useState("");
//         const {register, handleSubmit, formState:{errors}} = useForm();
//         const [showUrlSettings, setShowUrlSettings] = useState(false);
//         const [error, setError] = useState(false);
//         // const [loggedin, setLoggedin] = useState(false);

//         // const {loggedIn, setLoggedIn, setUserInfo} = useData();

//         const onSubmit = data=>doLogin(data).then(res=>{
//             console.log('_______________2 login response', res);
//             // [] trigger refresh
//             // setLoggedIn(true);
//             // console.log('setLoggedin:', refData.current.setLoggedin);
//             setLoggedin(true);
//             setUserInfo(res.data);
//             // useLoginData.userInfo = res.data;
//         }).catch(err=>{
//             setError(err);
//         });

//         // show/hide password icon
//         const [pwdType, setPwdType] = useState('password');
//         const handleTglPwd = () => {
//             if (pwdType==='password'){
//             setIcon("hide");
//             setPwdType('text')
//             } else {
//             setIcon("show")
//             setPwdType('password')
//             }
//         }

//         const [icon, setIcon] = useState("show");

//         // return <div>
//         //     <h1>{JSON.stringify(loggedin)}</h1>
//         //     [{loggedin&&children}]
//         //     {!loggedin&&<button type="button"
//         //         onClick={evt=>{
                    
//         //             setLoggedin(true);
//         //         }}
//         //     >login</button>}
//         // </div>

//         // return createPortal(test?<h1>logged in true [{loggedIn}] [{test}]</h1>:<h1>logged in false [{loggedIn}] [{test}]</h1>, document.getElementById('dialog-root'))
//         // return createPortal(loggedIn?'':<div>login</div>, document.getElementById('dialog-root'));
//         return loggedin?'':createPortal(<main className='login' style={{"zIndex":"9999999999"}}>
//                 <div className="modal show" tabIndex="-1">
//                     <div className="modal-dialog modal-fullscreen-sm-down">
//                         <div className="modal-content container shadow-lg">
//                             <form onSubmit={handleSubmit(onSubmit)}>
//                                 <div className="modal-header">
//                                     <img src={Logo} />
//                                     <h3 className="modal-title" >Log In</h3>
//                                     {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> */}
//                                 </div>
//                                 <div className="modal-body col-md-10 offset-md-1">
//                                         <div className="mb-3">
//                                             <label htmlFor="username" className="form-label">User name</label>
//                                             <input type="text" id="username" name="username" className="form-control" {...register("username", {required: true})} />
//                                             {errors.username && <p className="fld-error">This field is required</p>}
//                                             {/* <label htmlFor="exampleInputEmail1" className="form-label">Email address</label> */}
//                                             {/* <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" /> */}
//                                             {/* <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div> */}
//                                         </div>
//                                         <div className="mb-3">
//                                             <label htmlFor="password" className="form-label">Password</label>
//                                             <div className="input-group">
//                                                 <input type={pwdType} className="form-control" id="password" name="password" {...register("password", {required:true})} />
//                                                 <span className="input-group-text align-middle" onClick={handleTglPwd}>
//                                                     <img src={icon==="show"?IconEye:IconEyeSlash} className="align-middle pe-none p-0 m-0" style={{"width": "1.5em"}} />
//                                                 </span>                                            
//                                             </div>

//                                             {errors.password && <p className="fld-error">This field is required</p>}
//                                         </div>
//                                         {/* <div className="mb-3 form-check">
//                                             <input type="checkbox" className="form-check-input" id="checkMeOut" name="checkMeOut" />
//                                             <label className="form-check-label" htmlFor="checkMeOut">Check me out</label>
//                                         </div> */}
//                                         {error&&<div className="text-danger">{(error||{}).message||'unkown error'}</div>}
//                                 </div>
//                                 <div className="modal-footer">
//                                         <button type="button" className="btn btn-primary"
//                                             onClick={evt=>setShowUrlSettings(!showUrlSettings)}
//                                         >toggle url settings</button>
//                                         <button type="submit" className="btn btn-primary">Submit</button>
//                                     {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
//                                     <button type="button" className="btn btn-primary">Save changes</button> */}
//                                 </div>
//                             </form>
//                             <div className={"container "+(showUrlSettings?'':' d-none')}>
//                                 <UrlsSettings></UrlsSettings>
//                             </div>                        
//                         </div>

//                     </div>
//                 </div>
//             </main>,
//             document.getElementById('dialog-root')
//         );
//     };

//     return {
//         LoginResult,
//         Login,
//         loggedin,
//         setLoggedin,
//         logout,
//         getUserInfo: _getUserInfo
//     };
// }

// export function Login({}){
//     const [loggedin, setLoggedin] = useState(false);
//     // const [email, setEmail] = useState("");
//     // const [password, setPassword] = useState("");
//     const {register, handleSubmit, formState:{errors}} = useForm();
//     const [error, setError] = useState(false);
//     // const [loggedin, setLoggedin] = useState(false);

//     // const {loggedIn, setLoggedIn, setUserInfo} = useData();

//     const onSubmit = data=>doLogin(data).then(res=>{
//         // [] trigger refresh
//         // setLoggedIn(true);
//         console.log('setLoggedin:', setLoggedin);
//         setLoggedin(true);
//         // setUserInfo(res.data);
//     }).catch(err=>{
//         setError(err);
//     });

//     // show/hide password icon
//     const [pwdType, setPwdType] = useState('password');
//     const handleTglPwd = () => {
//         if (pwdType==='password'){
//            setIcon("hide");
//            setPwdType('text')
//         } else {
//            setIcon("show")
//            setPwdType('password')
//         }
//      }

//     const [icon, setIcon] = useState("show");

//     // return <div>
//     //     <h1>{JSON.stringify(loggedin)}</h1>
//     //     [{loggedin&&children}]
//     //     {!loggedin&&<button type="button"
//     //         onClick={evt=>{
                
//     //             setLoggedin(true);
//     //         }}
//     //     >login</button>}
//     // </div>

//     // return createPortal(test?<h1>logged in true [{loggedIn}] [{test}]</h1>:<h1>logged in false [{loggedIn}] [{test}]</h1>, document.getElementById('dialog-root'))
//     // return createPortal(loggedIn?'':<div>login</div>, document.getElementById('dialog-root'));
//     return loggedin?'':createPortal(<main className='login' style={{"zIndex":"9999999999"}}>
//             <div className="modal show" tabIndex="-1">
//                 <div className="modal-dialog modal-fullscreen-sm-down shadow-lg">
//                     <div className="modal-content container">
//                         <form onSubmit={handleSubmit(onSubmit)}>
//                             <div className="modal-header">
//                                 <img src={Logo} />
//                                 <h3 className="modal-title" >Log In</h3>
//                                 {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> */}
//                             </div>
//                             <div className="modal-body col-md-10 offset-md-1">
//                                     <div className="mb-3">
//                                         <label htmlFor="username" className="form-label">User name</label>
//                                         <input
//                                             type="text"
//                                             id="username" name="username"
//                                             className="form-control"
//                                             {...register("username", {required: true})} 
//                                         />
//                                         {errors.username && <p className="fld-error">This field is required</p>}
//                                         {/* <label htmlFor="exampleInputEmail1" className="form-label">Email address</label> */}
//                                         {/* <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" /> */}
//                                         {/* <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div> */}
//                                     </div>
//                                     <div className="mb-3">
//                                         <label htmlFor="password" className="form-label">Password</label>
//                                         <div className="input-group">
//                                             <input
//                                                 type={pwdType}
//                                                 className="form-control m-0 p-0"
//                                                 style={{
//                                                     "padding":"0",
//                                                     "borderRadius":"0"
//                                                 }}
//                                                 id="password"
//                                                 name="password"
//                                                 {...register("password", {required:true})} 
//                                             />
//                                             <span className="input-group-text align-middle" onClick={handleTglPwd}>
//                                                 <img src={icon==="show"?IconEye:IconEyeSlash} className="align-middle pe-none p-0 m-0" style={{"width": "1.5em"}} />
//                                             </span>                                            
//                                         </div>

//                                         {errors.password && <p className="fld-error">This field is required</p>}
//                                     </div>
//                                     {/* <div className="mb-3 form-check">
//                                         <input type="checkbox" className="form-check-input" id="checkMeOut" name="checkMeOut" />
//                                         <label className="form-check-label" htmlFor="checkMeOut">Check me out</label>
//                                     </div> */}
//                                     {error&&<div className="text-danger">{(error||{}).message||'unkown error'}</div>}
//                             </div>
//                             <div className="modal-footer">
//                                     <button type="submit" className="btn btn-primary">Submit</button>
//                                 {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
//                                 <button type="button" className="btn btn-primary">Save changes</button> */}
//                             </div>
//                         </form>
//                         <div className="container p-5">
//                             <UrlsSettings></UrlsSettings>
//                         </div>                        
//                     </div>

//                 </div>
//             </div>
//         </main>,
//         document.getElementById('dialog-root')
//     );
// };
